angular.module( 'angus.directives' ).directive( 'hedgePos', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				model: "=actionModel",
				settings: "=hedgePosWidgetSettings",
				widgetCode : "="
			},
			templateUrl: actionViewTemplates.hedgePosContainer
		};
	}
] );